import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92b7b96e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "refreshing-icon"
}
const _hoisted_2 = { class: "refresh-tips" }

import { reactive, watch, computed } from 'vue'
import SVGIcon from '@remote/components/SVGIcon.vue'
import { useCinemaStore } from '@remote/store/cinema'
import { isMobile } from '@remote/utils/base'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cinemaStore = useCinemaStore()

const isScraping = computed(() => {
  return cinemaStore.isScraping
})
const refreshRef = reactive({
  visible: false,
  refreshing: false,
  tips: '正在刷新列表，刷新完毕后将自动更新片库',
  lastTime: 0,
})

watch(isScraping, (val: boolean) => {
  if (isMobile()) return
  if (val) {
    refreshRef.refreshing = true
    refreshRef.lastTime = Date.now()
    refreshRef.visible = val
    refreshRef.tips = '正在刷新列表，刷新完毕后将自动更新片库'
  } else {
    const duration = Date.now() - refreshRef.lastTime
    const finish = () => {
      refreshRef.refreshing = false
      refreshRef.tips = '刷新完成'
      setTimeout(() => {
        refreshRef.visible = false
      }, 1500)
    }
    if (duration > 3000) {
      finish()
    } else {
      setTimeout(() => {
        finish()
      }, 3000 - duration)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["refresh-bar", [_unref(refreshRef).visible ? 'is-shown' : 'is-hidden']])
  }, [
    (_unref(refreshRef).refreshing)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(SVGIcon, { name: "refresh" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(refreshRef).tips), 1)
  ], 2))
}
}

})